import React from "react";

export default function Footer() {
    return (
      <footer>
        <p>&copy; 2025 Parafia św. Stanisława BM w Chruszczobrodzie</p>
      </footer>
    );
  }